var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"gzone-logo"},[_c('span',{staticClass:"gzone-title"},[_vm._v("空间热点控制台")])])
}]

export { render, staticRenderFns }